import { render, staticRenderFns } from "./DependencyStatusPickerItem.vue?vue&type=template&id=11d8aba4&scoped=true&"
import script from "./DependencyStatusPickerItem.vue?vue&type=script&lang=js&"
export * from "./DependencyStatusPickerItem.vue?vue&type=script&lang=js&"
import style0 from "./DependencyStatusPickerItem.vue?vue&type=style&index=0&id=11d8aba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d8aba4",
  null
  
)

export default component.exports